// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import meta from './data/meta.json';
import Zion from './utils/Zion';


// styles
import './styles/index.scss';
import './styles/graphic.scss';

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  // Initialize countries list (for production)
  setTimeout(() => {
    initCountriesList();
  }, 100);

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};


function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }

  // Initialize countries list
  initCountriesList();
}

function initCountriesList() {
  // Check if already initialized
  if (document.querySelector('.countries-list-container')) {
    return;
  }

  const countries = [
    'Afganistán',
    'Albania',
    'Argelia',
    'Antigua y Barbuda',
    'Armenia',
    'Azerbaiyán',
    'Bahamas',
    'Bangladesh',
    'Barbados',
    'Belarús',
    'Belice',
    'Birmania',
    'Bosnia',
    'Brasil',
    'Bután',
    'Cabo Verde',
    'Camboya',
    'Camerún',
    'Colombia',
    'Congo',
    'Costa de Marfil',
    'Cuba',
    'Dominica',
    'Egipto',
    'Eritrea',
    'Etiopía',
    'Fiji',
    'Gambia',
    'Georgia',
    'Ghana',
    'Granada',
    'Guatemala',
    'Guinea',
    'Haití',
    'Irán',
    'Iraq',
    'Jamaica',
    'Jordania',
    'Kazajstán',
    'Kirguistán',
    'Kosovo',
    'Kuwait',
    'Laos',
    'Líbano',
    'Liberia',
    'Libia',
    'Macedonia',
    'Marruecos',
    'Moldova',
    'Mongolia',
    'Montenegro',
    'Nepal',
    'Nicaragua',
    'Nigeria',
    'Pakistán',
    'R.D. del Congo',
    'Ruanda',
    'Rusia',
    'Saint Kitts y Nevis',
    'San Vicente y las Granadinas',
    'Santa Lucía',
    'Senegal',
    'Sierra Leona',
    'Somalia',
    'Sudán',
    'Sudán del Sur',
    'Siria',
    'Tailandia',
    'Tanzania',
    'Togo',
    'Túnez',
    'Uganda',
    'Uruguay',
    'Uzbekistán',
    'Yemen',
  ].sort((a, b) => a.localeCompare(b, 'es'));

  // Find the graphic box container
  const graphicBox = document.querySelector('#g-ai2html-graphic-box');
  if (!graphicBox) {
    return;
  }

  // Create container for countries list
  const container = document.createElement('div');
  container.className = 'countries-list-container';

  // Create list wrapper
  const listWrapper = document.createElement('div');
  listWrapper.className = 'countries-list-wrapper';

  // Create columns for mobile (2 columns)
  const mobileCol1 = document.createElement('div');
  mobileCol1.className = 'countries-col countries-col-mobile-1';
  const mobileCol2 = document.createElement('div');
  mobileCol2.className = 'countries-col countries-col-mobile-2';

  // Create columns for desktop (5 columns)
  const desktopCols = [];
  for (let i = 1; i <= 5; i++) {
    const col = document.createElement('div');
    col.className = `countries-col countries-col-desktop-${i}`;
    desktopCols.push(col);
  }

  // Distribute countries into columns (vertical order - down)
  const totalCountries = countries.length;
  const mobileColsCount = 2;
  const desktopColsCount = 5;

  // Calculate items per column for mobile
  const mobileItemsPerCol = Math.ceil(totalCountries / mobileColsCount);

  // Calculate items per column for desktop
  const desktopItemsPerCol = Math.ceil(totalCountries / desktopColsCount);

  countries.forEach((country, index) => {
    const countryItem = document.createElement('div');
    countryItem.className = 'country-item';

    // Add special class for "San Vicente y las Granadinas"
    if (country === 'San Vicente y las Granadinas') {
      countryItem.classList.add('country-item-long-name');
    }

    countryItem.textContent = country;

    // Mobile: distribute into 2 columns (vertical order)
    const mobileColIndex = Math.floor(index / mobileItemsPerCol);
    if (mobileColIndex === 0) {
      mobileCol1.appendChild(countryItem.cloneNode(true));
    } else {
      mobileCol2.appendChild(countryItem.cloneNode(true));
    }

    // Desktop: distribute into 5 columns (vertical order)
    const desktopColIndex = Math.floor(index / desktopItemsPerCol);
    desktopCols[desktopColIndex].appendChild(countryItem);
  });

  // Append mobile columns
  listWrapper.appendChild(mobileCol1);
  listWrapper.appendChild(mobileCol2);

  // Append desktop columns
  desktopCols.forEach((col) => {
    listWrapper.appendChild(col);
  });

  container.appendChild(listWrapper);

  // Create button container for mobile
  const buttonContainer = document.createElement('div');
  buttonContainer.className = 'countries-button-container';

  const button = document.createElement('button');
  button.className = 'countries-expand-btn';
  button.textContent = 'Desplegar todos los países';
  button.setAttribute('aria-expanded', 'false');

  button.addEventListener('click', () => {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      container.classList.remove('expanded');
      button.textContent = 'Desplegar todos los países';
      button.setAttribute('aria-expanded', 'false');
    } else {
      container.classList.add('expanded');
      button.textContent = 'Ver menos';
      button.setAttribute('aria-expanded', 'true');
    }

    // Update height for pym
    setTimeout(() => {
      if (window.pymChild) {
        window.pymChild.sendHeight();
      }
    }, 150);
  });

  buttonContainer.appendChild(button);
  container.appendChild(buttonContainer);

  // Insert after graphic box
  graphicBox.parentNode.insertBefore(container, graphicBox.nextSibling);

  // Calculate max-height for collapsed state (10 lines)
  // Wait for DOM to render
  setTimeout(() => {
    const listWrapper = container.querySelector('.countries-list-wrapper');
    if (listWrapper && window.innerWidth <= 735) {
      const firstCol = listWrapper.querySelector('.countries-col-mobile-1');
      if (firstCol) {
        const items = firstCol.querySelectorAll('.country-item');
        if (items.length >= 10) {
          let height = 0;
          for (let i = 0; i < 10; i++) {
            const rect = items[i].getBoundingClientRect();
            height += rect.height;
          }
          listWrapper.style.setProperty('--max-height-collapsed', `${height}px`);
        }
      }
    }
  }, 100);
}
